// dashboard-service.js
import BaseService from '../base-service';

class DashboardService extends BaseService {
  constructor() {
    super(''); // Base URL handled by BaseService
  }
  async getAvailableDates(network) {
    const params = new URLSearchParams({ network });
    return this.get(`DatesAvailability/?${params.toString()}`);
  }

  async getDashboardData(params, operations) {
    if (!params || !operations) {
      throw new Error('Missing required parameters');
    }

    const { network, dataset, year, timePeriod, subnet } = params;

    // Validate required parameters
    if (!network || !dataset || !year || !timePeriod) {
      throw new Error('All parameters (network, dataset, year, timePeriod) are required');
    }

    if (!Array.isArray(operations) || operations.length === 0) {
      throw new Error('Operations must be a non-empty array');
    }

    // Build query parameters
    const queryParams = new URLSearchParams({
      network,
      dataset,
      year,
      timePeriod, 
      subnet: subnet || 'RDCO and Externals', // Default fallback
      operations: operations.join(','), 
    });

    return this.get(`dashboard/getReportData/?${queryParams.toString()}`);
  }
}

export default new DashboardService();